import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { FormattedMessage } from 'react-intl'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Image from 'react-bootstrap/Image'

import EventBus from "../utils/EventBus"

import AuthService from "../services/AuthService"

const Login = () => {
  const [credentials, setCredentials] = useState({ username: "", password: "" })
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setCredentials((prevState) => ({ ...prevState, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setLoading(true)
    try {
      const response = await AuthService.login(credentials.username, credentials.password)
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data))
        EventBus.dispatch("login")
        navigate("/dashboard")
      } else {
        throw new Error("Invalid credentials")
      }
    } catch (err) {
      setError(err.message || "An unexpected error occurred")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container fluid className="d-flex justify-content-center align-items-center mt-5">
      <Row className="justify-content-center w-100">
        <Col xs={12} sm={8} md={6} lg={4} className="Login p-5">
          <h1 className="text-center"><Image src="logo_profundis_378_80.png" className="img-fluid" /></h1>
          <h2 className="text-center"><FormattedMessage id="loginTitle" defaultMessage="Please sign in" /></h2>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label><FormattedMessage id="loginEmail" defaultMessage="E-mail" /></Form.Label>
              <Form.Control
                type="email"
                name="username"
                value={credentials.username}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label><FormattedMessage id="loginPassword" defaultMessage="Password" /></Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={credentials.password}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Button type="submit" className="w-100" disabled={loading}>
              {loading ? <FormattedMessage id="textLoading" defaultMessage="Login" /> : <FormattedMessage id="loginButton" defaultMessage="Login" />}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  )
}

export default Login
